import 'swiper/css/bundle';
import Swiper from 'swiper';
import { Navigation, EffectCreative } from 'swiper/modules';

Swiper.use([Navigation, EffectCreative]);

const productSwiper = new Swiper('.image-swiper', {
  loop: true,
  slidesPerView: 1,
  centeredSlides: true,
  speed: 700,
  navigation: {
    nextEl: '.image-swiper-button-next',
    prevEl: '.image-swiper-button-prev',
  },
  breakpoints: {
    1000: {
      slidesPerView: 1.5,
    },
    1900: {
      slidesPerView: 2,
    },
  },
  effect: 'creative',
  creativeEffect: {
    prev: {
      translate: ['-100%', 62, -500],
    },
    next: {
      translate: ['100%', 62, -500],
    },
  },
});